import type { FC } from 'react';
import { Button } from '@george-labs.com/design-system';

import { t } from '@luna/i18n';
import { georgeStats } from '@shared/statistics';

import { useDashboardAppearanceChange } from './hooks/useDashboardAppearanceChange';
import { useActivePAPIProduct } from '../../../ActivePAPIProductContext';

export const DashboardAppearanceChange: FC = () => {
    const {
        _embedded: {
            customization: { hiddenOnOverview },
        },
    } = useActivePAPIProduct();

    const { hideAccountOnOverview, showAccountOnOverview } = useDashboardAppearanceChange();

    if (hiddenOnOverview === undefined) {
        return null;
    }

    if (hiddenOnOverview) {
        return (
            <Button
                className="g-inverted"
                icon={Button.ICON.SHOW_ON}
                size={Button.SIZE.SMALL}
                data-cy="account-settings-personalise-show-on-overview-button"
                onClick={() => {
                    georgeStats.trackEvent('productSettings', 'showAccountOnOverviewIconClicked');
                    showAccountOnOverview();
                }}
            >
                {t('app.showOverview')}
            </Button>
        );
    }

    return (
        <Button
            className="g-inverted"
            icon={Button.ICON.SHOW_OFF}
            size={Button.SIZE.SMALL}
            data-cy="account-settings-personalise-hide-on-overview-button"
            onClick={() => {
                georgeStats.trackEvent('productSettings', 'hideAccountOnOverviewIconClicked');
                hideAccountOnOverview();
            }}
        >
            {t('app.hideOverview')}
        </Button>
    );
};
